<template>
  <div class="page-header mt-4">
    <h1 class="page-title">{{ titulo }}</h1>
    <div v-if="link || boton">
      <b-button
        type="is-primary"
        icon-left="plus"
        :tag="boton ? 'button' : 'router-link'"
        :to="link"
        @click="$emit('click')"
      >
        {{ texto }}
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavComponent",
  props: ["titulo", "link", "texto", "boton"],
};
</script>
